import { css } from '@emotion/react'
import { Article, Featured } from '../../../types'
import { fetchFeaturedByArticle } from '@/lib/featured'
import { breakpoint, mq, colors, Card, font } from 'plume-ui'
import { ARTICLE_HREF, articlePath } from '@/lib/url'
import Link from 'next/link'
import { notPublishedYet } from '@/lib/api/contentful'
import React, { useEffect, useState } from 'react'
import { FormattedDate } from '../../atoms/FormattedDate'

type Props = {
  article: Article
}

export const FeaturedTOC: React.FC<Props> = (props) => {
  const [featured, setFeatured] = useState<Featured>()
  useEffect(() => {
    fetchFeaturedByArticle(props.article.id).then((res) => {
      if (res) {
        setFeatured(res)
      }
    })
  }, [])

  if (!featured) {
    return null
  }

  return (
    <div
      css={css`
        display: flex;
        background-color: ${colors.gray90};
        color: ${colors.white00};
        flex-direction: column;
        align-items: center;
        padding: 32px 24px 16px;
        ${mq.large} {
          margin-top: 40px;
          padding: 40px 96px 24px;
        }
      `}
    >
      <p
        css={css`
          margin: 0;
          font-size: 12px;
          letter-spacing: 0.1em;
        `}
      >
        FEATURED
      </p>
      <h3
        css={css`
          color: ${colors.white00};
          margin: 4px 0 0;
          font-size: 20px;
          line-height: 1.5;
          letter-spacing: 0.02em;
          &::after {
            display: block;
            content: '';
            width: 32px;
            height: 1px;
            margin: 12px auto 24px;
            background: ${colors.white00};
            ${mq.large} {
              margin: 8px auto 32px;
            }
          }
        `}
      >
        {featured.title}
      </h3>
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          max-width: ${breakpoint.extraLarge}px;
          margin: 0px auto;
          padding: 0;
          &::after {
            content: '';
            display: block;
            width: calc(33% - 15px);
          }
        `}
      >
        {featured.articles.map((article) =>
          notPublishedYet(article.publishedAt) ? null : (
            <Link
              as={articlePath(article)}
              href={ARTICLE_HREF}
              key={article.id}
            >
              <a
                css={css`
                  width: 100%;
                  margin-bottom: 16px;
                `}
              >
                <Card
                  css={css`
                    display: flex;
                    grid-column-gap: 16px;
                    background-color: ${colors.gray90};
                    ${mq.large} {
                      flex-direction: row-reverse;
                    }
                  `}
                >
                  <Card.Content
                    css={css`
                      padding: 0 !important;
                      flex-grow: 1;
                    `}
                  >
                    <p
                      css={css`
                        margin: 0;
                        font-weight: ${font.weight.bold};
                        line-height: 1.5;
                        font-size: 15px;
                        ${mq.large} {
                          font-size: 16px;
                        }
                      `}
                    >
                      {article.title}
                    </p>
                    <p
                      css={css`
                        margin: 4px 0 0;
                        color: ${colors.gray50};
                        font-size: 14px;
                      `}
                    >
                      <FormattedDate>{article.publishedAt}</FormattedDate>
                    </p>
                  </Card.Content>
                  <Card.Image
                    css={css`
                      figure {
                        width: 120px !important;
                        line-height: 0;
                        ${mq.large} {
                          width: 160px !important;
                        }
                      }
                    `}
                    src={article.headerImage.url}
                  />
                </Card>
              </a>
            </Link>
          )
        )}
      </div>
    </div>
  )
}
